import { CalenderEventFieldsFragment } from '__generated__/graphql';
import { Star, TrendingUp } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { EventHeader, EventInfo } from '../../common/Common/EventHeader';
import PopularEventLabel from '../../common/PopularEventLabel';
import UI from '../../common/UI';
import useLocale from '../../common/useLocale';
import useMediaDevice from '../../common/useMediaDevice';

interface EventCardProps {
  event: CalenderEventFieldsFragment;
}

export const EventCard = ({ event }: EventCardProps) => {
  const { t } = useTranslation();
  const { locale, formatNumber } = useLocale();

  return (
    <UI.NavCard
      href={`${event.checkout_url}?locale=${locale}`}
      sc={{ hasPanels: true, spacing: 'sm', flex: { direction: 'column', alignItems: 'space-between' } }}
      title={event.title}
      style={{ minWidth: 0 }}
    >
      <UI.Div sc={{ relative: true }} style={{ padding: 0, margin: -1, overflow: 'hidden' }}>
        <EventHeader
          headerUrl={event.header_url}
          size={900}
          sportType={event.sport_types[0]}
          sc={{ padding: 0, borderRadius: 'none' }}
          color={event.brand_color}
          alt={event.title}
        />
        {(event.average_rating > 0 || event.trend_score >= 60) && (
          <UI.FlexContainer
            sc={{
              absolute: true, padding: 3, small: true, gap: 0.25,
            }}
            style={{ top: 0, left: 0 }}
          >
            {event.average_rating > 0 && (
              <PopularEventLabel>
                <UI.Icon>
                  <Star fill="currentColor" />
                </UI.Icon>
                {' '}
                {formatNumber(event.average_rating, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </PopularEventLabel>
            )}
            {event.trend_score >= 60 && (
              <PopularEventLabel>
                <UI.Icon>
                  <TrendingUp />
                </UI.Icon>
                {' '}
                {t('website.popular')}
              </PopularEventLabel>
            )}
          </UI.FlexContainer>
        )}
      </UI.Div>
      <UI.Div>
        <UI.H3 sc={{ fontSize: 2, my: 0.25 }} style={{ fontWeight: 700 }}>
          <UI.Truncate>
            {event.title}
          </UI.Truncate>
        </UI.H3>
        <EventInfo
          event={{
            ...event,
            location: {
              ...event.location,
              id: null,
            },
          }}
          direction="column"
        />
      </UI.Div>
    </UI.NavCard>
  );
};

export const EventCardPlaceholder = () => {
  const device = useMediaDevice();

  return (
    <UI.Card
      sc={{ placeholder: true }}
      style={{
        padding: 0,
        paddingTop: device.isSmall ? `${100 / 1.75}%` : `${100 / 2}%`,
        paddingBottom: device.isSmall ? 88 : 96,
      }}
    />
  );
};

export default undefined;
